$ = require 'jquery'
BoardAddToOrganizationView = require 'app/scripts/views/board-menu/board-add-to-organization-view'
AddListPopoverView = require 'app/scripts/views/board/add-list-popover-view'
{ Analytics } = require '@trello/atlassian-analytics'
Auth = require 'app/scripts/db/auth'
Backgrounds = require 'app/scripts/data/backgrounds'
BoardBackgroundPrompt = require 'app/scripts/views/board/board-background-prompt'
BoardBackgroundPromptTooltip = require 'app/scripts/views/board-menu/board-background-prompt-tooltip'
BoardCleanUpView = require 'app/scripts/views/board/board-clean-up-view'
BoardDisplayHelpers = require 'app/scripts/views/internal/board-display-helpers'
BoardHeaderOrgMenuView = require 'app/scripts/views/board/board-header-org-menu-view'
BoardSidebarView = require 'app/scripts/views/board-menu/board-sidebar-view'
BoardTagSelectView = require 'app/scripts/views/organization/board-tag-select-view'
Browser = require '@trello/browser'
Card = require 'app/scripts/models/card'
{ canAddCard } = require 'app/scripts/views/card/card-limits-error'
CardListView = require 'app/scripts/views/card/card-list-view'
CardView = require 'app/scripts/views/card/card-view'
ChangeBoardVisibilityView = require 'app/scripts/views/board-menu/change-board-visibility-view'
Confirm = require 'app/scripts/views/lib/confirm'
Controller = require 'app/scripts/controller'
CopyBoardHeaderButtonTeams = require 'app/scripts/data/copy-board-header-button-teams'
CopyBoardView = require 'app/scripts/views/board/copy-board-view'
Dialog = require 'app/scripts/views/lib/dialog'
DirectoryView = require 'app/scripts/views/directory/directory-view'
DragSort = require 'app/scripts/views/lib/drag-sort'
FavIcon = require 'app/scripts/lib/favicon'
GoogleMapsApi = require 'app/scripts/lib/google-maps-api'
getExperiment = require 'app/scripts/lib/experiments/simple-test'
IdCache = require 'app/scripts/db/id-cache'
InspirationPopover = require 'app/scripts/views/onboarding/inspiration-popover'
InviteAcceptanceNotification = require 'app/scripts/views/board/invite-acceptance-notification'
{ getKey, Key, registerShortcutHandler, Scope, unregisterShortcutHandler, } = require '@trello/keybindings'
LabelState = require 'app/scripts/view-models/label-state'
Layout = require 'app/scripts/views/lib/layout'
LegacyPowerUps = require 'app/scripts/data/legacy-power-ups'
Limits = require 'app/scripts/lib/limits'
ListListView = require 'app/scripts/views/list/list-list-view'
ListView = require 'app/scripts/views/list/list-view'
locales = require('@trello/locale').supportedLocales
{ logoDomain } = require '@trello/config'
MemberBoardProfileView = require 'app/scripts/views/member/member-board-profile-view'
ModelLoader = require 'app/scripts/db/model-loader'
Payloads = require 'app/scripts/network/payloads'
PluginHeaderButtonsView = require 'app/scripts/views/plugin/plugin-header-buttons-view'
PluginRunner = require 'app/scripts/views/internal/plugins/plugin-runner'
PopOver = require 'app/scripts/views/lib/pop-over'
PostRender = require 'app/scripts/views/lib/post-render'
React = require 'react'
ReactDOM = require '@trello/react-dom-wrapper'
removeAllRanges = require 'app/scripts/lib/util/removeAllRanges'
ReopenBoardPopoverView = require 'app/scripts/views/board/reopen-board-popover-view'
{ TrelloStorage } = require '@trello/storage'
Util = require 'app/scripts/lib/util'
Tooltip = require 'app/scripts/views/lib/tooltip'
View = require 'app/scripts/views/internal/view'
WindowSize = require 'app/scripts/lib/window-size'
_ = require 'underscore'
closedTemplate = require 'app/scripts/views/templates/board_closed'
l = require 'app/scripts/lib/localize'
log = require 'app/scripts/debug/log'
moment = require 'moment'
ninvoke = require 'app/scripts/lib/util/ninvoke'
templates = require 'app/scripts/views/internal/templates'
headerTemplate = require 'app/scripts/views/templates/board_header'
permsTemplate = require 'app/scripts/views/templates/board_header_permissions'
pluginsChangedSignal = require 'app/scripts/views/internal/plugins/plugins-changed-signal'
{ Noun, Verb, track, trackUe } = require '@trello/analytics'
{ sendPluginUIEvent } = require('app/scripts/lib/plugins/plugin-behavioral-analytics')
warningTemplate = require 'app/scripts/views/templates/board_header_warnings'
{ UnsplashTracker } = require '@trello/unsplash'
{ featureFlagClient } = require '@trello/feature-flag-client'
{ isInspirationBoard } = require 'app/scripts/views/onboarding/helpers'
BoardHeaderAllMembersView = require 'app/scripts/views/board/board-header-all-members-view'
MemberOnBoardView = require 'app/scripts/views/member-menu-profile/member-on-board-view'
BoardMemberAddMultipleView = require 'app/scripts/views/board-menu/board-member-add-multiple-view'
{ maybeDisplayMemberLimitsError } = require 'app/scripts/views/board-menu/member-limits-error'
{ ErrorViews } = require 'app/common/data/error-views'
isDesktop = require('@trello/browser').isDesktop()
{ boardViewViewLoaders } = require './board-view-view-loaders'
{ BoardTemplateBadge } = require 'app/src/components/BoardTemplateBadge'
{ renderComponent } = require 'app/src/components/ComponentWrapper'
{ TeamlessCollaborationPrompt } = require 'app/src/components/TeamlessCollaborationPrompt'

{ renderTeamOnboardingPupPopover, renderTeamOnboardingPupTooltip, unmountTeamOnboardingPupPopover, unmountTeamOnboardingPupTooltip } = require './board-view-team-onboarding-pups'
{ onMemberAdd, renderBoardHeaderFacepile, openAllMembers, openAddMembers, joinBoard, showMemberProfile } = require './board-view-member'
{ unmountBoardBackgroundPrompt, unmountBoardBackgroundPromptPopover, renderBoardBackgroundPrompt, renderBoardBackgroundPromptPopover, getAllBackgroundClasses, defaultBoardBackground, clearBoardBackground, renderBoardBackground, renderBoardHeaderSubscribed } = require './board-view-background'
{ isTemplate, renderBoardTemplateReactSection, renderBoardTemplateBadge } = require './board-view-template'
{ _applySettings, renderOpen, _shouldCloseBoardMenu, _isFirstBoardEverLoaded, _isGhostUsingInviteLink, removeSidebarDisplayTypes, renderSidebarDisplayType, showSidebarOnOpen, renderSidebarState, toggleSidebar, setSidebarShow, showSidebar, hideSidebar } = require './board-view-sidebar'
{ permChange, renderPermissionLevel, changeVis, addBoardToTeam } = require './board-view-permission'
{ openListComposer, scrollToList, viewForList, postListListRender, renderLists, sortCommit } = require './board-view-list'
{ openCardComposerInFirstList, scrollToCard, preventScrollSelection, moveCard, dblClickAddListMenu, _insertCardPosition, moveCardRequested, copyCardRequested } = require './board-view-card'
{ markRelatedNotificationsRead } = require './board-view-notifications'
{ unmountInspirationPopover, renderInspirationPopover, renderInviteeOrientation } = require './board-view-onboarding'
{ renderJswCrossflowPopover } = require './board-view-jsw-crossflow-popover'
{ renderOrgChanges, refreshOrganization, openOrgMenu } = require './board-view-organization'
{ renderBoardWarnings } = require './board-view-limit'
{ openUnsubscribe } = require './board-view-unsubscribe'
{ reopen, _delete } = require './board-view-open-close-delete'
{ copyBoard } = require './board-view-copy'
{ onTeamCreatedFromCollaborationPrompt, unmountTeamlessCollaborationPrompt, renderTeamlessCollaborationPrompt, onWorkspacesPreambleCreateTeamSuccess, renderWorkspacesPreambleBoardHeaderButton, unmountWorkspacesPreambleBoardHeaderButton, renderWorkspacesPreambleInviteButton, unmountWorkspacesPreambleInviteButton } = require './board-view-collaboration'
{ reloadCustomFields, renderPluginButtons, renderBoardHeaderCalendar, renderAutoEnableCalendarPopover, navigateToBoard, closeDetailView, clickCloseDirectory, toggleDirectory, navigateToDirectory, showDirectory, closeDirectory, toggleCalendar, navigateToCalendarEvent, navigateToCalendar, navigateToBoardEvent, isShowingCalendar, showCalendar, closeCalendar, remove, toggleMap, navigateToMapEvent, navigateToMap, showMap, closeMap, renderBoardHeaderMap, toggleButler, navigateToButler, showButler, closeButler } = require './board-view-plugin'
{ renderBoardHeader, renderBoardHeaderStarred, toggleStarred, openFilter, clearFilters, showCleanUp, renderBoardViewsButton, removeBoardViewsButton } = require './board-view-header'
{ saveBoardName, keyDownEvent, onInputChanged, startRenaming, stopRenaming, updateControllerTitle } = require './board-view-name'
{ closeInviteAcceptanceNotification, buildInviteAcceptanceNotification, getNewlySignedUpInvitees, renderPopovers, renderInviteAcceptanceNotification, unmountInviteAcceptanceNotification } = require './board-view-invitation'

BUTLER_POWER_UP_ID = require 'app/scripts/data/butler-id'
CUSTOM_FIELDS_ID = require('@trello/config').customFieldsId
MAP_POWER_UP_ID = require('@trello/config').mapPowerUpId

MAX_FACEPILE_SIZE = 5

INVITE_ACCEPTANCE_NOTIFICATIONS_ENABLED_DATE = new Date('April 1, 2019')

module.exports = class BoardView extends View

  className: 'board-wrapper'

  events:
    'sortcommit': 'sortCommit'

    # For renaming boards in modern browsers
    'keydown .js-board-name-input': 'keyDownEvent'
    'input .js-board-name-input': 'onInputChanged'
    'change .js-board-name-input': 'onInputChanged'
      # Firefox uses "change" rather than "input"
    'blur .js-board-name-input': 'stopRenaming'
    'click .js-board-editing-target': 'startRenaming'

    'click .js-open-org-menu': 'openOrgMenu'

    'click .js-add-board-to-team:not(.no-edit)': 'addBoardToTeam'
    'click .js-change-vis': 'changeVis'
    'click .js-close-calendar': 'toggleCalendar'
    'click .js-calendar': 'toggleCalendar'
    'click .js-close-map': 'toggleMap'
    'click .js-map-btn': 'toggleMap'

    'click .js-filter-cards-indicator': 'openFilter'
    'click .js-filter-card-clear': 'clearFilters'
    'click .js-board-header-subscribed': 'openUnsubscribe'

    'click .js-star-board': 'toggleStarred'

    'click .js-show-sidebar': (e) ->
      trackUe('board sidebar', 'opens', 'sidebar', '', '', '', { boardId: @model.id, teamId: @model.getOrganization()?.id } )
      Analytics.sendClickedLinkEvent
        linkName: 'boardMenuDrawerToggleLink'
        source: 'boardScreen'
        containers:
          board:
            id: @model.id
          organization:
            id: @model.getOrganization()?.id
      @setSidebarShow()

    'click .js-dismiss-warning': (e) ->
      TrelloStorage.set(@$(e.currentTarget).attr('data-dismiss'), Date.now())
      @renderBoardWarnings()

    'dblclick #board': 'dblClickAddListMenu'
    'click #board': 'blurInputsOnBoardClick'

    'click .js-reopen': 'reopen'
    'click .js-delete': 'delete'

    'click .js-clean-up': 'showCleanUp'

    'prevent-scroll-selection': 'preventScrollSelection'

    'click .js-close-directory': 'clickCloseDirectory'

    'click .js-copy-board': 'copyBoard'
    'click .js-open-show-all-board-members': 'openAllMembers'
    'click .js-open-manage-board-members': 'openAddMembers'
    'click .js-join-board': 'joinBoard'

  constructor: ({ @headerBranding }) ->
    super

  initialize: ->
    super

    @sidebarView = @subview BoardSidebarView, @model, { boardView: @ }
    @inviteAcceptanceNotificationDiv = null
    @inviteAcceptanceNotificationComponent = null
    @hasSeenInviteAcceptanceNotification = false
    @hasSeenTeamlessCollaborationPrompt = false
    @workspacesPreambleBoardHeaderButtonTarget = null
    @workspacesPreamblePromptHasBeenSeen = false
    @workspacesPreambleInviteButtonTarget = null
    @teamOnboardingPupPopoverDiv = null
    @teamOnboardingPupTooltipDiv = null

    @makeDebouncedMethods 'refreshOrganization',
      'reloadCustomFields'
      'render'
      'renderBoardBackground'
      'renderBoardHeader'
      'renderBoardHeaderCalendar'
      'renderBoardHeaderSubscribed'
      'renderBoardHeaderMap'
      'renderBoardWarnings'
      'renderLists'
      'renderPermissionLevel'
      'updateControllerTitle'
      'renderBoardHeaderFacepile'
      'renderPluginButtons'
      'renderBoardViewsButton'

    @listenTo @model,
      'change:closed deleting': @renderDebounced
      'change:idOrganization': =>
        @reloadDirectoryPlugins = true
        @refreshOrganizationDebounced()
        @headerBranding()
      'change:memberships': @renderPermissionLevelDebounced
      'change:limits': @renderBoardWarningsDebounced
      'change:name': =>
        @renderBoardHeaderDebounced()
        @updateControllerTitleDebounced()
      'change:powerUps': ->
        @renderBoardHeaderMapDebounced()
        if !@model.isMapPowerUpEnabled()
          @closeMap()
        @renderBoardHeaderCalendarDebounced()
        if !@model.isPowerUpEnabled('calendar')
          @closeCalendar()
      'change:prefs.cardCovers': @renderListsDebounced
      'change:prefs.permissionLevel': =>
        @renderListsDebounced()
        @renderPermissionLevelDebounced()
        @renderBoardHeaderDebounced()
      'change:prefs.background change:prefs.backgroundTile change:prefs.backgroundBrightness': =>
        @renderBoardHeaderCalendarDebounced()
        @renderBoardBackgroundDebounced(true)
        @renderPluginButtonsDebounced()
      'change:prefs.isTemplate': @renderBoardHeaderDebounced
      'change:prefs.selfJoin': @renderBoardHeaderDebounced
      'change:subscribed': @renderBoardHeaderSubscribedDebounced
      'permChange': @permChange
      'ownedChange': @renderBoardHeaderDebounced
      'destroy': =>
        Controller.displayErrorPage
          errorType: ErrorViews.BOARD_NOT_FOUND

    @listenTo @model.memberList,
      'change:status': @renderBoardHeaderDebounced
      'add': @onMemberAdd
      'remove reset': @renderBoardHeaderFacepileDebounced

    @listenTo @model.boardPluginList, 'add reset', =>
      @reloadCustomFieldsDebounced()
      @renderBoardViewsButtonDebounced()

    @subscribe pluginsChangedSignal(@model), =>
      @renderBoardHeaderMapDebounced()
      if !@model.isMapPowerUpEnabled()
        @closeMap()
      @renderBoardHeaderCalendarDebounced()
      if !@model.isPowerUpEnabled('calendar')
        @closeCalendar()

      @renderBoardViewsButtonDebounced()

    @listenTo @model.viewState,
      'change:showSidebar': @renderSidebarState
      'change:sidebarDisplayType': @renderSidebarDisplayType
      'change:showBoardBackgroundPromptPopover': @renderBoardBackgroundPromptPopover

    @listenTo Auth.me().boardStarList, 'add remove reset', =>
      @renderBoardHeaderStarred()

    @memberTypeMe = @model.getMemberType(Auth.me())

    @refreshOrganization()

    @listScrollLeft = null
    @savingScroll = false
    @calcState = {}

    @listenTo @model.filter, 'change', =>
      @renderFilteringStatus()
      @renderBoardHeader()

    registerShortcutHandler(@onShortcut, { scope: Scope.Board })

    @listListView = @collectionSubview ListListView, @model.listList,
      id: 'board'
      model: @model
      className: 'u-fancy-scrollbar js-no-higher-edits'
      resetCallback: => @postListListRender()


    # Why are we listening to mousemove? Isn't mouseenter sufficient?
    #
    # 1. Hover your mouse over a card
    # 2. Hit an arrow key, moving the selected card, but not in a way that
    #    scrolls the page -- so the mouse is still hovering over the original
    #    card view.
    # 3. Move your mouse.
    #
    # If we were only listening to mouseenter, we'd never select the card,
    # because the mouse didn't re-enter it.
    @listenTo @listListView,
      'mouseMoveListView': (listView) ->
        list = listView.model
        @model.viewState.selectList listView.model
      'mouseLeaveListView': (listView) ->
        list = listView.model
        @model.viewState.selectList null
      'mouseMoveCardView': (listView, cardView) ->
        if @ignoreMouseCardSelects || PopOver.isVisible || DragSort.sorting
          return
        @model.viewState.selectCard cardView.model
      'mouseLeaveCardView': (listView, cardView) ->
        if @ignoreMouseCardSelects || PopOver.isVisible || DragSort.sorting
          return
        @model.viewState.selectCard null
      'moveCard': @moveCardRequested
      'copyCard': @copyCardRequested

    @_applySettings()
    @markRelatedNotificationsRead()

    @reloadDirectoryPlugins = false

    @sendGASEvent = featureFlagClient.get('dataeng.gasv3-event-tracking', false)
    @sendCoreGASEvent = featureFlagClient.get('dataeng.gasv3-core-event-tracking', false)

    # Analytics migration -- move this to controller to capture all URL changes
    if @sendCoreGASEvent
      Analytics.sendScreenEvent
        name: 'boardScreen',
        attributes:
          isTemplate: @model.isTemplate()
          visibility: @model.getPermLevel()
        containers:
          board:
            id: @model.id
          organization:
            id: @model.getOrganization()?.id || ''

    return

  renderTemplateTips: =>
    @sidebarView.renderTemplateTips()

  onMemberAdd: onMemberAdd

  unmountBoardBackgroundPrompt: unmountBoardBackgroundPrompt

  unmountBoardBackgroundPromptPopover: unmountBoardBackgroundPromptPopover

  renderBoardBackgroundPrompt: renderBoardBackgroundPrompt

  renderBoardBackgroundPromptPopover: renderBoardBackgroundPromptPopover

  isTemplate: isTemplate

  renderBoardTemplateReactSection: renderBoardTemplateReactSection

  renderBoardTemplateBadge: renderBoardTemplateBadge

  _applySettings: _applySettings

  permChange: permChange

  onShortcut: (event) =>
    editable = @model.editable()
    isLoggedIn = Auth.isLoggedIn()

    sendShortcutEvent = (shortcutKey, shortcutName, toggleValue) =>
      if !@sendGASEvent
        return

      Analytics.sendPressedShortcutEvent
        shortcutName: shortcutName
        source: 'boardScreen'
        keyValue: shortcutKey
        containers:
          board:
            id: @model.id
        attributes:
          toggleValue: toggleValue?.toLowerCase()

    switch getKey(event)
      when Key.q
        if isLoggedIn
          @model.filter.toggleQuietMode()
          event.preventDefault()
          track 'Keyboard Shortcuts', 'Q - My cards'
          sendShortcutEvent('q', 'myCardsShortcut')

      when Key.x
        @model.filter.clear()
        event.preventDefault()
        track 'Keyboard Shortcuts', 'X - Clear All Filters'
        sendShortcutEvent('x', 'clearAllFiltersShortcut')

      when Key.w
        @toggleSidebar()
        event.preventDefault()
        track 'Keyboard Shortcuts', 'W - Toggle Board Sidebar'
        toggleValue = if @model.viewState.get('showSidebar') then 'show' else 'hide'
        sendShortcutEvent('w', 'toggleBoardMenuDrawerShortcut', toggleValue)

      when Key.SemiColon
        wasShowingLabelText = LabelState.getShowText()
        LabelState.toggleText()
        event.preventDefault()
        toggleValue = if wasShowingLabelText then 'hide' else 'show'
        track(
          "Toggle Labels Text on Card Front",
          toggleValue,
          @model.id,
          "shortcut"
        )
        track 'Keyboard Shortcuts', '; - Toggle Label Text'
        sendShortcutEvent(';', 'toggleLabelTextShortcut', toggleValue)

      when Key.ArrowDown, Key.j
        @moveCard('down')
        event.preventDefault()
        track 'Keyboard Shortcuts', 'Keyboard Nav', 'Down'
        keyPressed = if getKey(event) == Key.j then 'j' else 'down'
        sendShortcutEvent(keyPressed, 'moveDownShortcut')

      when Key.ArrowUp, Key.k
        @moveCard('up')
        event.preventDefault()
        track 'Keyboard Shortcuts', 'Keyboard Nav', 'Up'
        keyPressed = if getKey(event) == Key.k then 'k' else 'up'
        sendShortcutEvent(keyPressed, 'moveUpShortcut')

      when Key.ArrowRight
        @moveCard('right')
        event.preventDefault()
        track 'Keyboard Shortcuts', 'Keyboard Nav', 'Right'
        sendShortcutEvent('rightArrow', 'moveRightShortcut')

      when Key.ArrowLeft
        @moveCard('left')
        event.preventDefault()
        track 'Keyboard Shortcuts', 'Keyboard Nav', 'Left'
        sendShortcutEvent('leftArrow', 'moveLeftShortcut')

      when Key.n
        if editable
          list = @model.viewState.getList()
          card = @model.viewState.getCard()

          if list?
            index =
              if card?
                list.openCards().indexOf(card) + 1
              else
                list.openCards().length

            @model.composer.save({
              list: list
              index: index
              vis: true
            })

            event.preventDefault()
            track 'Keyboard Shortcuts', 'N - Insert Card'
            sendShortcutEvent('n', 'insertCardShortcut')

      when Key.Escape
        if editable

          if DragSort.sorting
            DragSort.abort()
          else if !(Layout.isEditing() || PopOver.isVisible || Dialog.isVisible)
            if @model.composer.get('vis')
              @model.composer.save("vis", false)
            else if @model.viewState.get('listComposerOpen')
              @model.viewState.set('listComposerOpen', false)
            else
              @sidebarView.popView()

          if Controller.showingCalendar(@)
            $('.calendar-day.active').removeClass('active')

          event.preventDefault()

  openListComposer: openListComposer

  openCardComposerInFirstList: openCardComposerInFirstList

  scrollToList: scrollToList

  viewForList: viewForList

  scrollToCard: scrollToCard

  preventScrollSelection: preventScrollSelection

  markRelatedNotificationsRead: markRelatedNotificationsRead

  moveCard: moveCard

  unmountInspirationPopover: unmountInspirationPopover

  renderInspirationPopover: renderInspirationPopover

  renderTeamOnboardingPupPopover: renderTeamOnboardingPupPopover

  renderTeamOnboardingPupTooltip: renderTeamOnboardingPupTooltip

  unmountTeamOnboardingPupPopover: unmountTeamOnboardingPupPopover
  unmountTeamOnboardingPupTooltip: unmountTeamOnboardingPupTooltip

  renderClosed: ->
    @unmountTeamlessCollaborationPrompt()
    @unmountInspirationPopover()
    org = @model.getOrganization()
    isAtOrOverLimit = org?.isAtOrOverFreeBoardLimit()
    @$el.html closedTemplate({
      name: @model.get('name')
      canReopen: @model.owned()
      canDelete: @model.canDelete()
      deleting: @model.isDeleting()
      isAtOrOverLimit: isAtOrOverLimit
      isDesktop: isDesktop
      orgName: org?.get('displayName')
      billingUrl: org?.getBillingUrl()
    })
    @defaultBoardBackground()
    return

  _shouldCloseBoardMenu: _shouldCloseBoardMenu

  _isFirstBoardEverLoaded: _isFirstBoardEverLoaded

  _isGhostUsingInviteLink: _isGhostUsingInviteLink

  renderOpen: renderOpen

  render: ->
    if @model.get('closed') && !isInspirationBoard(@model.get('id'))
      @renderClosed()
    else
      @renderOpen()

    return @

  renderFilteringStatus: ->
    isFiltering = @model.filter.isFiltering()
    @$('.js-filter-cards-indicator').toggleClass('hide', !isFiltering)
    @$('.js-num-cards').toggleClass('hide', !isFiltering)
    @$('#board').toggleClass('filtering', isFiltering)

    queryString = @model.filter.toQueryString()
    currentQueryString = (new URLSearchParams(location.search)).toString()
    nextQueryString = (new URLSearchParams(queryString)).toString()
    # Calling replaceState too many times on a large board render will break
    # the progressive rendering of lists on a board
    if currentQueryString != nextQueryString
      history.replaceState(null, null, location.pathname + queryString)

  removeSidebarDisplayTypes: removeSidebarDisplayTypes

  renderSidebarDisplayType: renderSidebarDisplayType

  showSidebarOnOpen: showSidebarOnOpen

  renderSidebarState: renderSidebarState

  toggleSidebar: toggleSidebar

  setSidebarShow: setSidebarShow

  showSidebar: showSidebar

  hideSidebar: hideSidebar

  renderOrgChanges: renderOrgChanges

  refreshOrganization: refreshOrganization

  reloadCustomFields: reloadCustomFields

  renderBoardHeader: renderBoardHeader

  renderBoardWarnings: renderBoardWarnings

  renderPluginButtons: renderPluginButtons

  renderBoardHeaderStarred: renderBoardHeaderStarred

  toggleStarred: toggleStarred

  renderBoardHeaderCalendar: renderBoardHeaderCalendar

  renderAutoEnableCalendarPopover: renderAutoEnableCalendarPopover

  getAllBackgroundClasses: getAllBackgroundClasses

  defaultBoardBackground: defaultBoardBackground

  clearBoardBackground: clearBoardBackground

  renderBoardBackground: renderBoardBackground

  renderBoardHeaderSubscribed: renderBoardHeaderSubscribed

  renderBoardViewsButton: renderBoardViewsButton

  removeBoardViewsButton: removeBoardViewsButton

  saveBoardName: saveBoardName

  keyDownEvent: keyDownEvent

  onInputChanged: onInputChanged

  startRenaming: startRenaming

  stopRenaming: stopRenaming

  openOrgMenu: openOrgMenu

  renderPermissionLevel: renderPermissionLevel

  postListListRender: postListListRender

  renderLists: renderLists

  sortCommit: sortCommit

  closeInviteAcceptanceNotification: closeInviteAcceptanceNotification

  buildInviteAcceptanceNotification: buildInviteAcceptanceNotification

  getNewlySignedUpInvitees: getNewlySignedUpInvitees

  renderPopovers: renderPopovers

  renderInviteAcceptanceNotification: renderInviteAcceptanceNotification

  unmountInviteAcceptanceNotification: unmountInviteAcceptanceNotification

  renderBoardHeaderFacepile: renderBoardHeaderFacepile

  openAllMembers: openAllMembers

  openAddMembers: openAddMembers

  joinBoard: joinBoard

  changeVis: changeVis

  addBoardToTeam: addBoardToTeam

  toggleCalendar: toggleCalendar

  navigateToCalendarEvent: navigateToCalendarEvent

  navigateToCalendar: navigateToCalendar

  navigateToBoardEvent: navigateToBoardEvent

  navigateToBoard: navigateToBoard

  isShowingCalendar: isShowingCalendar

  toggleMap: toggleMap

  navigateToMapEvent: navigateToMapEvent

  navigateToMap: navigateToMap

  toggleButler: toggleButler

  navigateToButler: navigateToButler

  showMemberProfile: showMemberProfile

  showCalendar: showCalendar

  showMap: showMap

  showButler: showButler

  closeDetailView: closeDetailView

  closeCalendar: closeCalendar

  closeMap: closeMap

  closeButler: closeButler

  remove: ->
    if @calendarView?
      @calendarView.remove()
    unregisterShortcutHandler(@onShortcut)
    @unmountTeamlessCollaborationPrompt()
    @unmountWorkspacesPreambleBoardHeaderButton()
    @unmountWorkspacesPreambleInviteButton()
    @unmountTeamOnboardingPupPopover()
    @unmountTeamOnboardingPupTooltip()
    @removeBoardViewsButton()
    super

  clickCloseDirectory: clickCloseDirectory

  toggleDirectory: toggleDirectory

  navigateToDirectory: navigateToDirectory

  showDirectory: showDirectory

  closeDirectory: closeDirectory

  openFilter: openFilter

  clearFilters: clearFilters

  openUnsubscribe: openUnsubscribe

  # Because we are using jquery plugins that stop propagation on mousedown events
  # (jquery.dragscrollable and jquery.sortable), we need to handle blurring of inputs
  # and textareas ourselves.
  blurInputsOnBoardClick: (e) ->
    $target = $(e.target)

    # Ignore clicks on inputs and textareas. Note that inputs here can also be submit buttons
    # that are 'programatically' clicked by the DOM upon form submission (on enter keypress)
    clickedInput = $target.is('input') || $target.is('textarea')
    if (clickedInput)
      Util.stopPropagation(e)

    else
      $('input, textarea').blur()

  dblClickAddListMenu: dblClickAddListMenu

  reopen: reopen

  delete: _delete

  updateControllerTitle: updateControllerTitle

  copyBoard: copyBoard

  _insertCardPosition: _insertCardPosition

  moveCardRequested: moveCardRequested

  copyCardRequested: copyCardRequested

  showCleanUp: showCleanUp

  renderInviteeOrientation: renderInviteeOrientation

  renderJswCrossflowPopover: renderJswCrossflowPopover

  renderBoardHeaderMap: renderBoardHeaderMap

  onTeamCreatedFromCollaborationPrompt: onTeamCreatedFromCollaborationPrompt

  unmountTeamlessCollaborationPrompt: unmountTeamlessCollaborationPrompt

  renderTeamlessCollaborationPrompt: renderTeamlessCollaborationPrompt

  unmountWorkspacesPreambleBoardHeaderButton: unmountWorkspacesPreambleBoardHeaderButton

  renderWorkspacesPreambleBoardHeaderButton: renderWorkspacesPreambleBoardHeaderButton

  onWorkspacesPreambleCreateTeamSuccess: onWorkspacesPreambleCreateTeamSuccess

  renderWorkspacesPreambleInviteButton: renderWorkspacesPreambleInviteButton

  unmountWorkspacesPreambleInviteButton: unmountWorkspacesPreambleInviteButton
